var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16ZM22.4485 11.1515C22.9172 11.6201 22.9172 12.3799 22.4485 12.8485L14.4485 20.8485C13.9799 21.3172 13.2201 21.3172 12.7515 20.8485L9.55147 17.6485C9.08284 17.1799 9.08284 16.4201 9.55147 15.9515C10.0201 15.4828 10.7799 15.4828 11.2485 15.9515L13.6 18.3029L17.1757 14.7272L20.7515 11.1515C21.2201 10.6828 21.9799 10.6828 22.4485 11.1515Z",
    fill: "var(--green-500)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/check-Icon.94000eb05f4ac5d4afe32a8f9a9ad39a.svg";
export { ForwardRef as ReactComponent };